import * as actionTypes from './actionTypes';
import axios from '../../global/axios';
import FormData from 'form-data';
import logger from '../../global/logger';

export const fetchPlaylistsSuccess = (details) => {
    return {
        type: actionTypes.FETCH_PLAYLISTS_SUCCESS,
        details: details
    }
};

export const fetchPlaylistsFailure = (error) => {
    return {
        type: actionTypes.FETCH_PLAYLISTS_FAILURE,
        error: error
    };
};

export const fetchPlaylistsStart = () => {
    return {
        type: actionTypes.FETCH_PLAYLISTS_START
    }
};

export const fetchPlaylists = (callback) => {
    return dispatch => {
        dispatch(fetchPlaylistsStart());
        
        axios.get('/billboard/playlists.json')
        .then(res => {
            // logger.log("playlists:" + JSON.stringify(res.data));
            dispatch(fetchPlaylistsSuccess(res.data));

            dispatch(() => {
                if (callback) {
                    callback();
                }
            })
        })
        .catch(err => {
            dispatch(fetchPlaylistsFailure(err));
            alert(err.message);
        });
    }
};


export const createPlaylistStart = () => {
    return {
        type: actionTypes.CREATE_PLAYLIST_START,
    }
};

export const createPlaylistSuccess = (details) => {
    return {
        type: actionTypes.CREATE_PLAYLIST_SUCCESS,
        details: details
    }
};

export const createPlaylistFailure = (error) => {
    return {
        type: actionTypes.CREATE_PLAYLIST_FAILURE,
        error: error
    };
};

export const createPlaylist = (callback, title) => {

    return dispatch => {
        dispatch(createPlaylistStart());

        axios.post('/billboard/playlists.json', {
            playlist: {
                title: title || "Untitled Playlist",
            }
        })
        .then(res => {
            logger.log("createPlaylistSuccess: " + JSON.stringify(res.data));
            dispatch(createPlaylistSuccess(res.data));

            dispatch(fetchPlaylists(() => {
                dispatch(selectPlaylist(res.data));
            }));

            dispatch(() => {
                if (callback) {
                    callback();
                }
            })
        })
        .catch(err => {
            dispatch(createPlaylistFailure(err));
            alert(err.message);
        });
    }
};

export const deletePlaylistStart = () => {

    return {
        type: actionTypes.DELETE_PLAYLIST_START,
    }
};


export const deletePlaylistSuccess = (details) => {

    return {
        type: actionTypes.DELETE_PLAYLIST_SUCCESS,
        details: details
    }
};


export const deletePlaylistFailure = (error) => {

    return {
        type: actionTypes.DELETE_PLAYLIST_FAILURE,
        error: error
    };
};

export const deletePlaylist = (playlist_id, callback) => {

    return dispatch => {
        dispatch(deletePlaylistStart());
        // 

        axios.delete('/billboard/playlists/' + playlist_id + '.json')
        .then(res => {
            dispatch(deletePlaylistSuccess(res.data));

            dispatch(fetchPlaylists(() => {
                dispatch(() => {
                    if (callback) {
                        callback();
                    }
                })
            }));

            // dispatch(fetchPlaylists(() => {
            //     // dispatch(selectPlaylist(res.data));
            //     if (existing_index > 0) {
            //         dispatch(selectPlaylist(this.props.playlists[existing_index - 1]));
            //     } else if (this.props.playlists.length > 0) {
            //         dispatch(selectPlaylist(this.props.playlists[0]));
            //     } else {
            //         dispatch(selectPlaylist(null));
            //     }
            // }));

            
        })
        .catch(err => {
            dispatch(deletePlaylistFailure(err));
            alert(err.message);
        });
    }
};

export const exportPlaylistStart = () => {

    return {
        type: actionTypes.EXPORT_PLAYLIST_START,
    }
};

export const exportPlaylistSuccess = (details) => {
    return {
        type: actionTypes.EXPORT_PLAYLIST_SUCCESS,
        details: details
    }
};


export const exportPlaylistFailure = (error) => {
    return {
        type: actionTypes.EXPORT_PLAYLIST_FAILURE,
        error: error
    };
};

export const exportPlaylist = (playlist_id, callback) => {

    return dispatch => {
        dispatch(exportPlaylistStart());

        axios.post('/billboard/playlists/' + playlist_id + '/export.json')
        .then(res => {
            dispatch(exportPlaylistSuccess(res.data));

            dispatch(() => {
                if (res.data.download_url) {
                    const iframe = document.createElement('iframe');
                    iframe.style.display = 'none';
                    iframe.src = res.data.download_url;
                    document.body.appendChild(iframe);
                    setTimeout(() => document.body.removeChild(iframe), 30000);
                }
                if (callback) {
                    callback();
                }
            })
        })
        .catch(err => {
            dispatch(exportPlaylistFailure(err));
            alert(err.message);
        });
    }
};


export const selectPlaylist = (playlist) => {
    return {
        type: actionTypes.SELECT_PLAYLIST,
        playlist: playlist,
    }
};

export const fetchDevicesSuccess = (details) => {
    return {
        type: actionTypes.FETCH_DEVICES_SUCCESS,
        details: details
    }
};

export const fetchDevicesFailure = (error) => {
    return {
        type: actionTypes.FETCH_DEVICES_FAILURE,
        error: error
    };
};

export const fetchDevicesStart = () => {
    return {
        type: actionTypes.FETCH_DEVICES_START
    }
};

export const fetchDevices = (callback) => {
    return dispatch => {
        dispatch(fetchDevicesStart());

        axios.get('/billboard/devices.json')
        .then(res => {
            logger.log("devices:" + JSON.stringify(res.data));
            dispatch(fetchDevicesSuccess(res.data));

            dispatch(() => {
                if (callback) {
                    callback();
                }
            })
        })
        .catch(err => {
            dispatch(fetchDevicesFailure(err));
            alert(err.message);
        });
    }
};

export const selectDevice = (device) => {
    return {
        type: actionTypes.SELECT_DEVICE,
        device: device,
    }
};

export const pairNewDevice = () => {
    return {
        type: actionTypes.PAIR_NEW_DEVICE,
    }
};

export const submitCode = (code) => {

    return dispatch => {
        dispatch(submitCodeStart());

        axios.post('/billboard/devices.json', {
            pairing_code: code,
        })
        .then(res => {
            logger.log("devices:" + JSON.stringify(res.data));
            dispatch(submitCodeSuccess(res.data));

            fetchDevices(() => {
                dispatch(pairNewDeviceFinish());

                dispatch(() => {
                    if (callback) {
                        callback();
                    }
                })
            });
        })
        .catch(err => {
            dispatch(submitCodeFailure(err));
            alert(err.message);
        });
    }
};

export const submitCodeStart = () => {
    return {    
        type: actionTypes.SUBMIT_CODE_START,
    }
};

export const submitCodeSuccess = () => {
    return {
        type: actionTypes.SUBMIT_CODE_SUCCESS,
    }
};

export const submitCodeFailure = (error) => {
    return {
        type: actionTypes.SUBMIT_CODE_FAILURE,
        error: error,
    }
};

export const selectMediaLibrary = (media_library) => {
    return {
        type: actionTypes.SELECT_MEDIA_LIBRARY,
        media_library: media_library,
    }
};

export const fetchMediaStart = () => {
    return {
        type: actionTypes.FETCH_MEDIA_START,
    }
};

export const fetchMediaSuccess = (details) => {
    return {
        type: actionTypes.FETCH_MEDIA_SUCCESS,
        details: details
    }
};

export const fetchMediaFailure = (error) => {
    return {
        type: actionTypes.FETCH_MEDIA_FAILURE,
        error: error,
    }
};

export const fetchMedia = (callback) => {
    return dispatch => {
        dispatch(fetchMediaStart());

        axios.get('/billboard/media.json')
            .then(res => {
                dispatch(fetchMediaSuccess(res.data));

                dispatch(() => {
                    if (callback) {
                        callback();
                    }
                })
            })
            .catch(err => {
                dispatch(fetchMediaFailure(err));
                alert(err.message);
            });
    }
};

export const selectMedia = (media) => {
    return {
        type: actionTypes.SELECT_MEDIA,
        media: media,
    }
};

export const uploadMediaStart = () => {
    return {
        type: actionTypes.UPLOAD_MEDIA_START,
    }
};

export const uploadMediaSuccess = (details) => {
    return {
        type: actionTypes.UPLOAD_MEDIA_SUCCESS,
        details: details,
    }
};

export const uploadMediaFailure = (error) => {
    return {
        type: actionTypes.UPLOAD_MEDIA_FAILURE,
        error: error,
    }
};

export const uploadMedia = (media_file, playlist_id, callback) => {
    return dispatch => {
        dispatch(uploadMediaStart());
        logger.log("uploadMedia: " + media_file);

        let random_id = crypto.randomUUID();

        var mime_type = media_file.type;
        var filename = media_file.name;
        var extension = filename.replace(/^.*\./, '');

        var key = "uploads/" + random_id + "." + extension;
        var accessKeyId = "";
        var policy = "";
        var signature = "";

        var acl = "public-read";
        var content_type = mime_type;
        var success_action_status = "201";

        axios.post('/billboard/signed_urls/v2', {
            doc: {
                title: random_id + "." + extension,
            },
            content_type: mime_type,
        })
        .then(res => {
            logger.log("signed_urls: " + JSON.stringify(res.data));

            key = res.data.key;
            accessKeyId = res.data.AWSAccessKeyId;

            policy = res.data.policy;
            signature = res.data.signature;
            content_type = res.data.content_type;

            let request_data = new FormData();
            request_data.append('key', key);
            request_data.append('AWSAccessKeyId', accessKeyId);
            request_data.append('acl', acl);
            request_data.append('policy', policy);
            request_data.append('signature', signature);
            request_data.append('Content-Type', content_type);
            // The signed policy carries a Cache-Control condition, and an
            // S3 POST policy condition REQUIRES the matching form field —
            // omit it and S3 rejects the upload. Sent verbatim from the
            // server so the policy and the field can never disagree.
            if (res.data.cache_control) {
                request_data.append('Cache-Control', res.data.cache_control);
            }
            request_data.append('success_action_status', success_action_status);
            // `file` must stay last — S3 ignores any field that follows it.
            request_data.append('file', media_file);

            logger.log("request_data: " + JSON.stringify(request_data));

            axios.post('https://worshipkit.s3.amazonaws.com', request_data,
            {
                responseType: 'json',
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
            .then(awsResponse => {
                logger.log("uploadMediaSuccess: " + JSON.stringify(awsResponse.data));

                let parser = new DOMParser();
                let xml = parser.parseFromString(awsResponse.data, 'text/xml');
                let url = xml.getElementsByTagName('Location')[0].textContent;

                logger.log("url: " + url);

                var attach_url = "/billboard/media/add_upload.json";
                if (playlist_id) {
                    attach_url = "/billboard/playlists/" + playlist_id + "/add_upload.json";
                }

                axios.post(attach_url + '', {
                    upload_details: {
                        title: filename,
                        credit: "",
                        url: url
                    }
                })
                .then(res => {
                    logger.log("add_upload: " + JSON.stringify(res.data));
                    dispatch(uploadMediaSuccess(res.data));

                    dispatch(fetchMedia(() => {
                        // dispatch(selectMedia(res.data));
                    }));

                    dispatch(() => {
                        if (callback) {
                            callback();
                        }
                    })
                })
                .catch(err => {
                    dispatch(uploadMediaFailure(err));
                    alert(err.message);
                });
            })
            .catch(awsError => {
                dispatch(uploadMediaFailure(awsError));
                alert(awsError.message);
            });
        })
        .catch(err => {
            dispatch(uploadMediaFailure(err));
            alert(err.message);
        });
    }
};

export const saveMediaStart = () => {

    return {
        type: actionTypes.SAVE_MEDIA_START,
    }
};


export const saveMediaSuccess = (details) => {

    return {
        type: actionTypes.SAVE_MEDIA_SUCCESS,
        details: details,
    }
};


export const saveMediaFailure = (error) => {

    return {
        type: actionTypes.SAVE_MEDIA_FAILURE,
        error: error,
    }
};

export const saveMedia = (media, callback) => {

    return dispatch => {
        dispatch(saveMediaStart());

        axios.put('/billboard/media/' + media.id + '.json', {
            billboard_media_item: media
        })
        .then(res => {
            logger.log("saveMediaSuccess: " + JSON.stringify(res.data));
            dispatch(saveMediaSuccess(res.data));

            dispatch(() => {
                logger.log("callback");
                if (callback) {
                    callback();
                }
            })
        })
        .catch(err => {
            dispatch(saveMediaFailure(err));
            alert(err.message);
        });
    }
};


export const deleteMediaStart = () => {

    return {
        type: actionTypes.DELETE_MEDIA_START,
    }
};

export const deleteMediaSuccess = (details) => {
    return {
        type: actionTypes.DELETE_MEDIA_SUCCESS,
        details: details,
    }
};

export const deleteMediaFailure = (error) => {

    return {
        type: actionTypes.DELETE_MEDIA_FAILURE,
        error: error,
    }
};


export const deleteMedia = (media_id, callback) => {

    return dispatch => {
        dispatch(deleteMediaStart());

        axios.delete('/billboard/media/' + media_id + '.json')
        .then(res => {
            dispatch(deleteMediaSuccess(res.data));

            dispatch(() => {
                if (callback) {
                    callback();
                }
            })
        })
        .catch(err => {
            dispatch(deleteMediaFailure(err));
            alert(err.message);
        });
    }
};

export const deleteMediaFromPlaylistStart = () => {

    return {
        type: actionTypes.DELETE_MEDIA_FROM_PLAYLIST_START,
    }
};


export const deleteMediaFromPlaylistSuccess = (details) => {

    return {
        type: actionTypes.DELETE_MEDIA_FROM_PLAYLIST_SUCCESS,
        details: details,
    }
};


export const deleteMediaFromPlaylistFailure = (error) => {

    return {
        type: actionTypes.DELETE_MEDIA_FROM_PLAYLIST_FAILURE,
        error: error,
    }
};

export const deleteMediaFromPlaylist = (playlist_id, item_id, callback) => {

    return dispatch => {
        dispatch(deleteMediaFromPlaylistStart());

        axios.delete("/billboard/playlists/" + playlist_id + "/remove_media_item.json", {
            data: {
                item_id: item_id
            }
        })
        .then(res => {
            dispatch(deleteMediaFromPlaylistSuccess(res.data));
        
            dispatch(() => {
                if (callback) {
                    callback();
                }
            })
        })
        .catch(err => {
            dispatch(deleteMediaFromPlaylistFailure(err));
            alert(err.message);
        });
    }
};


export const attachMediaStart = () => {
    return {
        type: actionTypes.ATTACH_MEDIA_START,
    }
};

export const attachMediaSuccess = (details) => {
    return {
        type: actionTypes.ATTACH_MEDIA_SUCCESS,
        details: details,
    }
};

export const attachMediaFailure = (error) => {
    return {
        type: actionTypes.ATTACH_MEDIA_FAILURE,
        error: error,
    }
};

export const attachMedia = (playlist_id, media_id, callback) => {
    return dispatch => {
        dispatch(attachMediaStart());

        axios.post("/billboard/playlists/" + playlist_id + "/add_media_item.json", {
            media_item_id: media_id
        })
        .then(res => {
            dispatch(attachMediaSuccess(res.data));

            dispatch(() => {
                if (callback) {
                    callback();
                }
            })
        })
        .catch(err => {
            dispatch(attachMediaFailure(err));
            alert(err.message);
        });
    }
};


export const selectDeviceByID = (device_id, callback) => {
    return dispatch => {
        dispatch(fetchPlaylistsStart());
        
        axios.get('/billboard/playlists.json')
        .then(res => {
            // logger.log("playlists:" + JSON.stringify(res.data));
            dispatch(fetchPlaylistsSuccess(res.data));
            dispatch(selectDeviceByIDFinish(device_id));

            dispatch(() => {
                if (callback) {
                    callback();
                }
            })
        })
        .catch(err => {
            dispatch(fetchPlaylistsFailure(err));
            alert(err.message);
        });
    }
    
};

export const selectDeviceByIDFinish = (device_id) => {
    return {
        type: actionTypes.SELECT_DEVICE_BY_ID,
        device_id: device_id,
    }
}

export const selectPlaylistByID = (playlist_id, callback) => {
    return dispatch => {
        dispatch(fetchPlaylistsStart());
        
        axios.get('/billboard/playlists.json')
        .then(res => {
            // logger.log("playlists:" + JSON.stringify(res.data));
            dispatch(fetchPlaylistsSuccess(res.data));
            dispatch(selectPlaylistByIDFinish(playlist_id));

            dispatch(() => {
                if (callback) {
                    callback();
                }
            })
        })
        .catch(err => {
            dispatch(fetchPlaylistsFailure(err));
            alert(err.message);
        });
    }
};

export const selectPlaylistByIDFinish = (playlist_id) => {
    return {
        type: actionTypes.SELECT_PLAYLIST_BY_ID,
        playlist_id: playlist_id,
    }
}

export const deleteDeviceStart = () => {
    return {
        type: actionTypes.DELETE_DEVICE_START,
    }
};

export const deleteDeviceSuccess = (details) => {
    return {
        type: actionTypes.DELETE_DEVICE_SUCCESS,
        details: details,
    }
};

export const deleteDeviceFailure = (error) => {
    return {
        type: actionTypes.DELETE_DEVICE_FAILURE,
        error: error,
    }
};

export const deleteDevice = (device_id, callback) => {
    return dispatch => {
        dispatch(deleteDeviceStart());

        axios.delete('/billboard/devices/' + device_id + '.json')
        .then(res => {
            dispatch(deleteDeviceSuccess(res.data));
        })
        .catch(err => {
            dispatch(deleteDeviceFailure(err));
            alert(err.message);
        });
    }
};

export const updateDeviceStart = () => {
    return { type: actionTypes.UPDATE_DEVICE_START };
};

export const updateDeviceSuccess = (details) => {
    return { type: actionTypes.UPDATE_DEVICE_SUCCESS, details: details };
};

export const updateDeviceFailure = (error) => {
    return { type: actionTypes.UPDATE_DEVICE_FAILURE, error: error };
};

export const updateDevice = (device_id, attrs) => {
    return dispatch => {
        dispatch(updateDeviceStart());

        axios.put('/billboard/devices/' + device_id + '.json', { device: attrs })
        .then(res => {
            dispatch(updateDeviceSuccess(res.data));
        })
        .catch(err => {
            dispatch(updateDeviceFailure(err));
            alert(err.message);
        });
    }
};

// ---- Series art (#482) -----------------------------------------------
//
// Org-scoped settings: an on/off toggle plus a manually uploaded image
// URL that overrides whatever Planning Center sync last cached. Backed
// by Billboard::SeriesArtController (GET/PATCH /billboard/series_art.json).

export const fetchSeriesArtStart = () => {
    return { type: actionTypes.FETCH_SERIES_ART_START };
};

export const fetchSeriesArtSuccess = (details) => {
    return { type: actionTypes.FETCH_SERIES_ART_SUCCESS, details: details };
};

export const fetchSeriesArtFailure = (error) => {
    return { type: actionTypes.FETCH_SERIES_ART_FAILURE, error: error };
};

export const fetchSeriesArt = () => {
    return dispatch => {
        dispatch(fetchSeriesArtStart());

        axios.get('/billboard/series_art.json')
        .then(res => {
            dispatch(fetchSeriesArtSuccess(res.data));
        })
        .catch(err => {
            dispatch(fetchSeriesArtFailure(err));
            alert(err.message);
        });
    }
};

export const updateSeriesArtStart = () => {
    return { type: actionTypes.UPDATE_SERIES_ART_START };
};

export const updateSeriesArtSuccess = (details) => {
    return { type: actionTypes.UPDATE_SERIES_ART_SUCCESS, details: details };
};

export const updateSeriesArtFailure = (error) => {
    return { type: actionTypes.UPDATE_SERIES_ART_FAILURE, error: error };
};

// `attrs` is a subset of { series_art_enabled, series_art_manual_url }.
// An empty-string series_art_manual_url clears the manual override
// (falls back to the PCO-derived art) — see SeriesArtController#update.
export const updateSeriesArt = (attrs, callback) => {
    return dispatch => {
        dispatch(updateSeriesArtStart());

        axios.patch('/billboard/series_art.json', attrs)
        .then(res => {
            dispatch(updateSeriesArtSuccess(res.data));
            dispatch(() => {
                if (callback) {
                    callback(res.data);
                }
            });
        })
        .catch(err => {
            dispatch(updateSeriesArtFailure(err));
            alert(err.message);
        });
    }
};

export const uploadSeriesArtStart = () => {
    return { type: actionTypes.UPLOAD_SERIES_ART_START };
};

export const uploadSeriesArtSuccess = (details) => {
    return { type: actionTypes.UPLOAD_SERIES_ART_SUCCESS, details: details };
};

export const uploadSeriesArtFailure = (error) => {
    return { type: actionTypes.UPLOAD_SERIES_ART_FAILURE, error: error };
};

// Same direct-to-S3 flow as uploadMedia (signed POST policy from
// /billboard/signed_urls/v2, then a straight POST to the bucket), but the
// resulting URL is PATCHed to /billboard/series_art.json as the manual
// override instead of being attached to a playlist.
export const uploadSeriesArt = (media_file, callback) => {
    return dispatch => {
        dispatch(uploadSeriesArtStart());
        logger.log("uploadSeriesArt: " + media_file);

        let random_id = crypto.randomUUID();

        var mime_type = media_file.type;
        var filename = media_file.name;
        var extension = filename.replace(/^.*\./, '');

        var accessKeyId = "";
        var policy = "";
        var signature = "";

        var acl = "public-read";
        var content_type = mime_type;
        var success_action_status = "201";

        axios.post('/billboard/signed_urls/v2', {
            doc: {
                title: random_id + "." + extension,
            },
            content_type: mime_type,
        })
        .then(res => {
            let key = res.data.key;
            accessKeyId = res.data.AWSAccessKeyId;

            policy = res.data.policy;
            signature = res.data.signature;
            content_type = res.data.content_type;

            let request_data = new FormData();
            request_data.append('key', key);
            request_data.append('AWSAccessKeyId', accessKeyId);
            request_data.append('acl', acl);
            request_data.append('policy', policy);
            request_data.append('signature', signature);
            request_data.append('Content-Type', content_type);
            if (res.data.cache_control) {
                request_data.append('Cache-Control', res.data.cache_control);
            }
            request_data.append('success_action_status', success_action_status);
            // `file` must stay last — S3 ignores any field that follows it.
            request_data.append('file', media_file);

            axios.post('https://worshipkit.s3.amazonaws.com', request_data,
            {
                responseType: 'json',
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
            .then(awsResponse => {
                let parser = new DOMParser();
                let xml = parser.parseFromString(awsResponse.data, 'text/xml');
                let url = xml.getElementsByTagName('Location')[0].textContent;

                axios.patch('/billboard/series_art.json', { series_art_manual_url: url })
                .then(res => {
                    dispatch(uploadSeriesArtSuccess(res.data));
                    dispatch(() => {
                        if (callback) {
                            callback(res.data);
                        }
                    });
                })
                .catch(err => {
                    dispatch(uploadSeriesArtFailure(err));
                    alert(err.message);
                });
            })
            .catch(awsError => {
                dispatch(uploadSeriesArtFailure(awsError));
                alert(awsError.message);
            });
        })
        .catch(err => {
            dispatch(uploadSeriesArtFailure(err));
            alert(err.message);
        });
    }
};

// ---- Per-playlist series art (#482) --------------------------------------
//
// Sends toggle + connect/upload/disconnect/remove state changes to
// PATCH /api/v2/playlists/:id via the same auth-scoped surface the
// SPA already uses for everything else on the playlist. Empty strings
// are sent for the "Disconnect" and "Remove" flows so the server-side
// normalizer clears the columns.
export const updatePlaylistSeriesArtStart = () => {
    return { type: actionTypes.UPDATE_PLAYLIST_SERIES_ART_START };
};

export const updatePlaylistSeriesArtSuccess = (details) => {
    return { type: actionTypes.UPDATE_PLAYLIST_SERIES_ART_SUCCESS, details: details };
};

export const updatePlaylistSeriesArtFailure = (error) => {
    return { type: actionTypes.UPDATE_PLAYLIST_SERIES_ART_FAILURE, error: error };
};

export const updatePlaylistSeriesArt = (playlist_id, attrs, callback) => {
    return dispatch => {
        dispatch(updatePlaylistSeriesArtStart());
        axios.patch('/api/v2/playlists/' + playlist_id, { playlist: attrs })
        .then(res => {
            dispatch(updatePlaylistSeriesArtSuccess(res.data));
            if (callback) {
                callback(res.data);
            }
        })
        .catch(err => {
            dispatch(updatePlaylistSeriesArtFailure(err));
            alert(err.message);
        });
    };
};

export const uploadPlaylistSeriesArtStart = () => {
    return { type: actionTypes.UPLOAD_PLAYLIST_SERIES_ART_START };
};

export const uploadPlaylistSeriesArtSuccess = (details) => {
    return { type: actionTypes.UPLOAD_PLAYLIST_SERIES_ART_SUCCESS, details: details };
};

export const uploadPlaylistSeriesArtFailure = (error) => {
    return { type: actionTypes.UPLOAD_PLAYLIST_SERIES_ART_FAILURE, error: error };
};

// Same direct-to-S3 flow as `uploadSeriesArt` and `uploadMedia`:
// (1) get a signed POST policy from /billboard/signed_urls/v2,
// (2) POST the file straight to the bucket,
// (3) PATCH the resulting URL + filename onto the playlist so the
//     model persists both the source ("upload") and the display data.
export const uploadPlaylistSeriesArt = (playlist_id, media_file, callback) => {
    return dispatch => {
        dispatch(uploadPlaylistSeriesArtStart());
        logger.log("uploadPlaylistSeriesArt: " + media_file);

        let random_id = crypto.randomUUID();
        let mime_type = media_file.type;
        let filename = media_file.name;
        let extension = filename.replace(/^.*\./, '');
        let acl = "public-read";
        let content_type = mime_type;
        let success_action_status = "201";

        axios.post('/billboard/signed_urls/v2', {
            doc: { title: random_id + "." + extension },
            content_type: mime_type,
        })
        .then(res => {
            let key = res.data.key;
            let accessKeyId = res.data.AWSAccessKeyId;
            let policy = res.data.policy;
            let signature = res.data.signature;
            content_type = res.data.content_type;

            let request_data = new FormData();
            request_data.append('key', key);
            request_data.append('AWSAccessKeyId', accessKeyId);
            request_data.append('acl', acl);
            request_data.append('policy', policy);
            request_data.append('signature', signature);
            request_data.append('Content-Type', content_type);
            if (res.data.cache_control) {
                request_data.append('Cache-Control', res.data.cache_control);
            }
            request_data.append('success_action_status', success_action_status);
            request_data.append('file', media_file);

            axios.post('https://worshipkit.s3.amazonaws.com', request_data, {
                responseType: 'json',
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            .then(awsResponse => {
                let parser = new DOMParser();
                let xml = parser.parseFromString(awsResponse.data, 'text/xml');
                let url = xml.getElementsByTagName('Location')[0].textContent;

                axios.patch('/api/v2/playlists/' + playlist_id, {
                    playlist: {
                        series_art_enabled: true,
                        series_art_source: 'upload',
                        series_art_uploaded_url: url,
                        series_art_uploaded_filename: filename,
                    }
                })
                .then(patchRes => {
                    dispatch(uploadPlaylistSeriesArtSuccess(patchRes.data));
                    if (callback) {
                        callback(patchRes.data);
                    }
                })
                .catch(err => {
                    dispatch(uploadPlaylistSeriesArtFailure(err));
                    alert(err.message);
                });
            })
            .catch(awsError => {
                dispatch(uploadPlaylistSeriesArtFailure(awsError));
                alert(awsError.message);
            });
        })
        .catch(err => {
            dispatch(uploadPlaylistSeriesArtFailure(err));
            alert(err.message);
        });
    };
};

export const fetchSeriesArtServiceTypesStart = () => {
    return { type: actionTypes.FETCH_SERIES_ART_SERVICE_TYPES_START };
};

export const fetchSeriesArtServiceTypesSuccess = (details) => {
    return { type: actionTypes.FETCH_SERIES_ART_SERVICE_TYPES_SUCCESS, details: details };
};

export const fetchSeriesArtServiceTypesFailure = (error) => {
    return { type: actionTypes.FETCH_SERIES_ART_SERVICE_TYPES_FAILURE, error: error };
};

// Lists the caller org's Planning Center service types, used by the
// "Connect..." picker modal in the playlist editor.
export const fetchSeriesArtServiceTypes = (callback) => {
    return dispatch => {
        dispatch(fetchSeriesArtServiceTypesStart());
        axios.get('/api/v2/playlists/series_art_service_types')
        .then(res => {
            dispatch(fetchSeriesArtServiceTypesSuccess(res.data));
            if (callback) {
                callback(res.data);
            }
        })
        .catch(err => {
            dispatch(fetchSeriesArtServiceTypesFailure(err));
        });
    };
};